

class CartDrawer extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this._ufcOnResize = this._ufcOnResize.bind(this);
    window.addEventListener('resize', this._ufcOnResize, { passive: true });
  }

  /** fixed 若落在带 transform 的祖先内会相对该祖先定位，易表现为「左上角」；用视口像素 + !important 钉死右上 */
  _applyUfcPopoverPanelPosition() {
    if (!this.classList.contains('ufc-cart-drawer--popover')) return;
    const inner = this.querySelector('.drawer__inner');
    if (!inner) return;
    const pad = 12;
    inner.style.setProperty('position', 'fixed', 'important');
    inner.style.setProperty('top', pad + 'px', 'important');
    inner.style.setProperty('right', pad + 'px', 'important');
    inner.style.setProperty('left', 'auto', 'important');
    inner.style.setProperty('bottom', 'auto', 'important');
    inner.style.setProperty('transform', 'none', 'important');
    inner.style.setProperty('inset-inline-start', 'auto', 'important');
    inner.style.setProperty('inset-inline-end', 'auto', 'important');
  }

  _clearUfcPopoverPanelPosition() {
    if (!this.classList.contains('ufc-cart-drawer--popover')) return;
    const inner = this.querySelector('.drawer__inner');
    if (!inner) return;
    ['position', 'top', 'right', 'left', 'bottom', 'transform', 'inset-inline-start', 'inset-inline-end'].forEach(function (p) {
      inner.style.removeProperty(p);
    });
  }

  _ufcOnResize() {
    if (this.classList.contains('active')) this._applyUfcPopoverPanelPosition();
  }

  setHeaderCartIconAccessibility() {
    const root = document.querySelector('#cart-icon-bubble');
    if (!root) return;
    /* 首页用直达选餐的链接（.cart-box__home-meal），勿绑 a[href]，否则会误拦其它链接并卡死 */
    const cartTrigger = root.querySelector('.cart-box__trigger');
    if (!cartTrigger) return;
    cartTrigger.setAttribute('aria-haspopup', 'dialog');
    cartTrigger.setAttribute('aria-controls', 'CartDrawer');
    const openFrom = (event) => {
      event.preventDefault();
      this.open(cartTrigger);
    };
    cartTrigger.addEventListener('click', openFrom);
    cartTrigger.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartTrigger);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    // const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    // if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      this._applyUfcPopoverPanelPosition();
      try {
        this.dispatchEvent(new CustomEvent('ufc:cart-drawer-opened', { bubbles: true }));
      } catch (_e) {}
    });

    this.addEventListener(
      'transitionend',
      () => {
        // console.log('asass');
        // const containerToTrapFocusOn = this.classList.contains('is-empty')
        //   ? this.querySelector('.drawer__inner-empty')
        //   : document.getElementById('CartDrawer');
        // const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        // trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }


  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    var pop = this.classList.contains('ufc-cart-drawer--popover');
    var done = () => {
      document.body.classList.remove('overflow-hidden');
      this.classList.remove('animate');
    };
    if (pop) {
      this._clearUfcPopoverPanelPosition();
      done();
    } else {
      setTimeout(done, 500);
    }
  }
  
  renderContents(parsedState) {
    // console.log(this);
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
